import { WA_LINK, BRAND } from "../lib/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label={`WhatsApp ${BRAND.whatsapp}`}
      data-testid="whatsapp-float"
      className="fixed z-50 bottom-20 md:bottom-6 right-4 md:right-6 h-14 w-14 flex items-center justify-center bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform"
      style={{ borderRadius: "50%" }}
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.5 0 .17 5.33.17 11.88c0 2.09.55 4.14 1.6 5.94L0 24l6.34-1.66a11.87 11.87 0 0 0 5.72 1.46h.01c6.56 0 11.89-5.33 11.89-11.89 0-3.17-1.24-6.16-3.44-8.43zM12.07 21.6h-.01a9.7 9.7 0 0 1-4.94-1.35l-.35-.21-3.76.99 1-3.67-.23-.38a9.7 9.7 0 0 1-1.5-5.2c0-5.37 4.37-9.74 9.75-9.74 2.6 0 5.05 1.01 6.89 2.86a9.68 9.68 0 0 1 2.85 6.88c0 5.38-4.37 9.82-9.69 9.82zm5.6-7.32c-.31-.15-1.83-.9-2.11-1-.28-.1-.48-.15-.69.15-.2.31-.78 1-.96 1.2-.18.2-.36.23-.66.08-.31-.15-1.3-.48-2.48-1.53-.92-.82-1.54-1.83-1.72-2.14-.18-.31-.02-.48.13-.63.13-.13.31-.35.46-.53.15-.18.2-.31.3-.51.1-.2.05-.38-.03-.53-.08-.15-.69-1.66-.94-2.27-.25-.6-.5-.52-.69-.53l-.58-.01c-.2 0-.53.08-.8.38-.28.31-1.05 1.03-1.05 2.52 0 1.48 1.08 2.92 1.23 3.12.15.2 2.12 3.24 5.14 4.54.72.31 1.28.49 1.71.63.72.23 1.37.2 1.88.12.58-.09 1.83-.75 2.08-1.47.26-.72.26-1.34.18-1.47-.07-.13-.28-.2-.59-.36z" />
      </svg>
    </a>
  );
}
